define('models/zendesk/SectionCollection',['underscore','ObjectCollection','LocalStorage','app','models/zendesk/SectionModel'],
    function (_,ObjectCollection,LocalStorage,app,SectionModel) {
    //
    // Collection Zendesk Section
    //
    return ObjectCollection.extend({

        name:'ZendeskSectionCollection',
        route:'apiZendeskSection',
        bundleId:'sections',
        idAttribute:'id',
        model:SectionModel,

        getOrderSections:function(isComplete){
            return this.filter(function(section){
                return section.isOrder(isComplete);
            });
        }

    }).extend(LocalStorage);
});
